import { httpClient } from '../lib/http-client';
import { TentativaLogin } from '../types';

/**
 * Service para gerenciamento de tentativas de login
 */
export class TentativasLoginService {
  static async getTentativasLogin(): Promise<TentativaLogin[]> {
    return httpClient.get<TentativaLogin[]>('/api/tentativas-login');
  }

  static async getTentativaLogin(id: number): Promise<TentativaLogin> {
    return httpClient.get<TentativaLogin>(`/api/tentativas-login/${id}`);
  }

  static async createTentativaLogin(data: Partial<TentativaLogin>): Promise<TentativaLogin> {
    return httpClient.post<TentativaLogin>('/api/tentativas-login', data);
  }

  static async updateTentativaLogin(
    id: number,
    data: Partial<TentativaLogin>
  ): Promise<TentativaLogin> {
    return httpClient.put<TentativaLogin>(`/api/tentativas-login/${id}`, data);
  }

  static async deleteTentativaLogin(id: number): Promise<{ success: boolean }> {
    return httpClient.delete<{ success: boolean }>(`/api/tentativas-login/${id}`);
  }
}

